import React from 'react'
import { Container, Header, Image, Button } from 'semantic-ui-react'
import Fade from 'react-reveal/Fade';
import '../styles/registerSection.scss';

const RegisterSection = () => (
  <div className="content-deck register" id="register">
    <h1 className="content-deck__headline">Register</h1>
    <Container>
      <Fade right cascade>

      <div className="register__options">

        <div className="register__card">
          <div className="register__name">Regular</div>
          <div className="register__price">Faculty: <br/><span>$500</span></div>
          <div className="register__price">Graduate Students: <br/><span>$425</span></div>
          <div className="register__date">Ended October 16th</div>
          <div className="register__button">

            <Button disabled href="https://secure.touchnet.net/C21544_ustores/web/product_detail.jsp?PRODUCTID=2443&FROMQRCODE=true" target="_blank" size="large" inverted basic>
            Register
          </Button>
          </div>
        </div>
        <div className="register__card">
          <div className="register__name">Late</div>
          <div className="register__price">Faculty: <br/><span>$575</span></div>
          <div className="register__price">Graduate Students: <br/> <span>$500</span></div>
          <div className="register__date">Ended November 1st</div>
          <div className="register__button">

              <Button disabled href="https://secure.touchnet.net/C21544_ustores/web/product_detail.jsp?PRODUCTID=2443&FROMQRCODE=true" target="_blank" size="large" inverted basic>
            Register
          </Button>
          </div>
        </div>
        <div className="register__card">
          <div className="register__name">Meals Only</div>
          <div className="register__price"> <br/><span>$300</span></div>
          <div className="register__space"></div>
          <div className="register__date">Ended November 1st</div>
          <div className="register__button">

              <Button disabled href="https://secure.touchnet.net/C21544_ustores/web/product_detail.jsp?PRODUCTID=2443&FROMQRCODE=true" target="_blank" size="large" inverted basic>
            Register
          </Button>
          </div>
        </div>
      </div>
         </Fade>
    <h4 className="content-deck__subhead">Online registration has ended. There will be onsite registration beginning the first day of the conference.</h4>
    </Container>
  </div>
)

export default RegisterSection;


// WEBPACK FOOTER //
// ./src/sections/registerSection.js